<template>   
  <div>
    <v-card flat>      
        <div>
          <v-row no-gutters fill-height>
            <v-expansion-panels
              v-model="panel"
              :disabled="disabled"
              multiple 
              accordion     
            >
              <v-expansion-panel>
                <v-expansion-panel-header>Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content >
                  <!-- =============Start Search Condition============= -->
                      <v-row dense >
                        <!-- From Date -->
                        <v-col
                          class="pl-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >                           
                        <DxDateBox  
                            label="From date"                            
                            :value="stDate" 
                            display-format="yyyy-MM-dd" 
                            :acceptCustomValue="false"
                            @value-changed="e => {stDate = e.value && getStrFormat(e.value)}"
                            dense
                        /> 
                        </v-col>
                        <!-- To date -->
                        <v-col
                          class="pl-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >                           
                        <DxDateBox  
                            label="To date"                            
                            :value="edDate" 
                            display-format="yyyy-MM-dd" 
                            :acceptCustomValue="false"
                            @value-changed="e => {edDate = e.value && getStrFormat(e.value)}"
                            dense
                        />
                        </v-col>                      
                        <!-- Department -->
                        <v-col
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Department"
                              v-model="deptName" 
                              :items="deptNameList" 
                              item-value="deptName" 
                              return-object 
                              outlined 
                              dense
                              @change = "groupList"
                            >
                            </v-select>
                        </v-col>
                        <!-- Group -->
                        <v-col
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Group"
                              v-model="respName" 
                              :items="respNameList" 
                              item-value="respName"
                              return-object
                              outlined 
                              dense
                              
                            >
                            </v-select>
                        </v-col>
                        <!-- Ship No -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Ship No"
                              v-model="shipNo" 
                              :items="shipNoList" 
                              return-object 
                              item-value="shipNo" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- QM Part -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="QM Part"
                              v-model="qmPartName" 
                              :items="qmPartNameList" 
                              return-object 
                              item-value="qmPartName" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- Inspection Result -->
                        <v-col class="mt-2"
                          cols="6"
                          sm="6"
                          md="4" >
                            <v-select
                                label="Result Insp."
                                v-model="resultInsp"
                                :items="resultInspList"
                                item-value="insResCd"
                                item-text="insResNm"
                                return-object
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                      </v-row>
                    <!-- ==========End Search Condition================= -->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
         <!-- Change theme -->
         <v-fab-transition>
          <v-btn
            v-show="!isMobileDevice" 
            @click="btnRetrieve"
            absolute
            top
            right
            fab
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card>     
    <v-card class="mt-2">  
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>  
          <div class="ml-2">Count List: {{ gridMainList.length }}</div>
          <v-data-table
            :mobile-breakpoint="800"
            :items-per-page="20"
            :headers="headers"
            :items="gridMainList"
            fixed-header
            :height="isMobileDevice ? undefined : 600"
            :search="search"
            :dense="true"
            :sort-by="[]"
            :sort-desc="[false]"
            :dark="dark"
            class="mobile-clean-table"
            style="max-width: 100%; overflow-x: auto;"
          >
             <template v-slot:item="{ item, isMobile }">    
                <mobile-card-item
                    v-if="isMobile"
                    :item="item"
                    :header-value="item.rno"
                    :active="selectedRowIndex === item.rno"
                    :fields="mobileFields"             
                    >
                   <template v-slot:actions>
                    <div class="d-flex align-center justify-end">
                      <v-btn
                          v-if="autSaveYN==='S'"
                          x-small
                          class="px-2"
                          outlined
                          :dark="dark"
                          dense
                          @click="editItem(item)"
                        ><v-icon x-small left >mdi-pencil</v-icon>
                          <span x-small>Input result</span>
                        </v-btn>
                    </div>
                  </template>
                  <template v-slot:plans>
                      <div class="d-flex align-center justify-end">                        
                        <div class="d-flex align-center mr-4"> 
                          <v-checkbox 
                            v-model="item.wowShow" 
                            label="Owner" 
                            dense 
                            hide-details 
                            disabled 
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </div>
                        <div class="d-flex align-center">
                          <v-checkbox 
                            v-model="item.wclShow" 
                            label="Class" 
                            dense 
                            hide-details 
                            disabled 
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </div>
                      </div>
                    </template>
                    <template v-slot:actuals>
                      <div class="d-flex align-center justify-end">                        
                        <div class="d-flex align-center mr-4"> 
                          <v-checkbox 
                            v-model="item.wowAct" 
                            label="Owner" 
                            dense 
                            hide-details 
                            disabled 
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </div>
                        <div class="d-flex align-center">
                          <v-checkbox 
                            v-model="item.wclAct" 
                            label="Class" 
                            dense 
                            hide-details 
                            disabled 
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </div>
                      </div>
                    </template>
                </mobile-card-item>
                <tr v-else class="custom-pc-row">
                  <td class="v-data-table__divider text-center">{{ item.rno }}</td>
                  <td class="v-data-table__divider text-center">{{ item.shipNo }}</td>
                  <td class="v-data-table__divider text-center">{{ item.insDateShow }}</td>
                  <!-- <td class="v-data-table__divider">{{ item.actions }}</td> -->
                  <td class="v-data-table__divider text-center">
                    <div class="d-flex align-center">
                       <v-btn
                          v-if="autSaveYN==='S'"
                          x-small
                          class="px-1"
                          outlined
                          :dark="dark"
                          dense
                          @click="editItem(item)"
                        ><v-icon x-small left >mdi-pencil</v-icon>
                          <span x-small>Input result</span>
                        </v-btn>
                    </div>
                  </td>
                  <td class="v-data-table__divider text-center">{{ item.insResCd }}</td>
                  <td class="v-data-table__divider text-center">{{ item.insResDe }}</td>
                  <td class="v-data-table__divider text-center">{{ item.resPaintMK }}</td>
                  <td class="v-data-table__divider text-right">{{ item.mh }}</td>
                  <td class="v-data-table__divider">{{ item.itemDesc2 }}</td>
                  <td class="v-data-table__divider text-center">{{ item.qmPartNm }}</td>
                  <td class="v-data-table__divider text-center">{{ item.kindNm }}</td>
                  <td class="v-data-table__divider ">{{ item.locNm }}</td>
                  <td class="v-data-table__divider ">{{ item.deptNm }}</td>
                  <td class="v-data-table__divider ">{{ item.respNmeng }}</td>
                  <td class="v-data-table__divider">
                    <div class="d-flex align-center">
                      <v-checkbox 
                        label="Owner"
                        v-model="item.wowShow"
                        disabled
                        dense
                      ></v-checkbox>
                      <v-checkbox  
                        label="Class"            
                        v-model="item.wclShow"
                        disabled
                        dense
                      ></v-checkbox>
                    </div>
                  </td>                  
                  <td class="v-data-table__divider">
                    <div class="d-flex align-center">
                        <v-checkbox 
                          label="Owner"
                          v-model="item.wowAct"
                          disabled
                          dense
                        ></v-checkbox>
                        <v-checkbox  
                          label="Class"            
                          v-model="item.wclAct"
                          disabled
                          dense
                        ></v-checkbox>
                    </div>
                  </td>                  
                </tr>
              </template>   
          </v-data-table> 

          <!-- Snackbar Dialog -->
          <v-snackbar
            v-model="snack"
            :timeout="2000"
            :color="snackColor"
          >
            {{ snackText }}
      
            <template v-slot:action="{ attrs }">
              <v-btn
                v-bind="attrs"
                text
                @click="snack = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>    

          <!-- Dialog  Input Result -->  
            <v-dialog
              v-model="dialog"
              max-width="90%"
              persistent
              transition="dialog-bottom-transition"
            >              
              <v-card :dark="dark">
                <v-card-title>
                  <span class="text-h5">{{titleInput}}</span>
                </v-card-title>    
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-if="autDept === 'Y'"
                      >
                      <v-select
                        v-model="inputResult.insResCd" 
                        :items="resultInspList"
                        item-value="insResCd"
                        item-text="insResNm"
                        label="Owner*"
                        required
                        :disabled="disabledOwner"
                        @change="changeSelect(inputResult)"
                      ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-if="autDept === 'Y'"
                      > 
                        <v-select
                          v-model="inputResult.insResDe" 
                          :items="resultInspDeList"
                          item-value="insResDe"
                          item-text="insResDeNm"
                          label="Delegation*"
                          required
                          :disabled="disabledDel"                          
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-if="autDept === 'Y'"
                      > 
                        <v-select
                          v-model="inputResult.resPaintMK" 
                          :items="resultInspPaintMKList"
                          item-value="resPaintMK"
                          item-text="resPaintMKNm"
                          label="Maker*"
                          required
                          :disabled="disabledMaker"
                        ></v-select>
                      </v-col>
                      
                      <v-col
                        cols="6"
                        sm="6"
                        md="4"
                        v-if="autDept === 'Y'"
                      >
                        <v-checkbox
                          v-model="inputResult.wowAct"
                          label="Owner Actual"
                          color="red"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="6"
                        md="4"
                        v-if="autDept === 'Y'"
                      >
                        <v-checkbox
                          v-model="inputResult.wclAct"
                          label="Class Actual"
                          color="indigo"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="inputResult.mh"
                          label="M/H reject"
                          :disabled="disabledMh"
                        ></v-text-field>
                      </v-col>                      
                    </v-row>
                  </v-container>
                </v-card-text>
    
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeResult"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="saveResult(inputResult)"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
    </v-card>
    <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
   
  </div>  
</template>

<script>
import  {
        mdiAccount,
        mdiPencil,
        mdiShareVariant,
        mdiDelete,
        mdiSelectSearch,
        mdiMapSearch 

      } from '@mdi/js'

import  { getShipList, 
          getDeptList,
          getRespList,
          getQMPartList,
          getResultList
      } from '@/api/view/tqm/80/v80comm.js'

import  {
        getAutSaveYN,
        getAutInspection,
        getInsResultChk,
        getInsResultChkDel,
        getShipIncharge,
        getCloseYN,
        getEvalPoint,
        v80b1020List,
        v80b1020Update,
      } from '@/api/view/tqm/80/v80b1020.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import { mobileTableMixin } from '@/mixins/mobileTableMixin.js' // Import mixin mới
import EventBus from '@/components/event-bus';
import {
getDateFormat,
} from '@/utils/common.js'

import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify' // message

export default {
name: "v80b1020",
mixins: [baseview, BaseDataGrid, mobileTableMixin],
data: () => ({
  fab: false,
  dark: false,
  isMobileDevice: false, // Biến mới
  icons: {
    mdiAccount,
    mdiPencil,
    mdiShareVariant,
    mdiDelete,
    mdiSelectSearch,
    mdiMapSearch

  },
  // for Dialog
  dialog: false,
  snack: false,
  snackColor: '',
  snackText: '',
  max25chars: v => v.length <= 25 || 'Input too long!',
  modeIndex: -1,  
  inputResult: {
    insResDe: '',
    resPaintMK: '',
    mh:'',
    insResCd:'', 
    deptCd:'',
    qcYN: '',
    wowAct: false,
    wclAct: false,

  }, 
  insNRes:null,
  // for Search condition
  stDate: '',
  edDate: '',
  shipNoList: [],
  shipNo: '',
  deptName: '',
  deptNameList: [],
  deptCd: '',
  respName: '',
  respNameList: [],
  respCd: '',
  qmPart: '',
  qmPartName:'',
  qmPartNameList: [],
  resultInsp: '',
  resultInspList: [],
  resultInspDe: '',
  resultInspDeList: [],

  resultInspPaintMKList: [],
 
  panel: [0],
  disabled: false,
  hover: true,

  // for Data list
  gridMainList: [],
  listSize: 0,
  
  mobile: true,
  search: '',
  headers: [
              {
                text: 'No',
                align: 'center',
                value: 'rno',
                divider: true,
                sortable: false,
                
              },
              { text: 'Ship No', sortable: false, divider: true,align: 'center',value: 'shipNo', },
              { text: 'Inspection Date',sortable: false, divider: true, align: 'center',value: 'insDateShow', },
              { text: 'Actions', sortable: false, divider: true,align: 'center',value: 'actions', },
              { text: 'Owner result', sortable: false, divider: true,align: 'center',value: 'insResCd', },
              { text: 'Delegation result', sortable: false, divider: true,align: 'center',value: 'insResDe', },
              { text: 'Maker result', sortable: false, divider: true,align: 'center',value: 'resPaintMK', },
              { text: 'MH Reject/USD', sortable: false, divider: true,align: 'center',value: 'mh',  },
              { text: 'Description', sortable: false, divider: true,align: 'center',value: 'itemDesc2',  },
              { text: 'QM Part', sortable: false, divider: true,align: 'center',value: 'qmPartNm',  },
              { text: 'Kind Inspection', sortable: false, divider: true,align: 'center',value: 'kindNm',  },
              { text: 'Location', sortable: false, divider: true,align: 'center',value: 'locNm',  },
              { text: 'Department', sortable: false, divider: true,align: 'center',value: 'deptNm',  },
              { text: 'Work Group', sortable: false, divider: true,align: 'center',value: 'respNmeng',  },
              { text: 'Witness Plan', sortable: false, divider: true,align: 'center',value: 'plans',  },
              { text: 'Witness Actual', sortable: false, divider: true,align: 'center',value: 'actuals', },
            ],
    selectedRowIndex: null, // Lưu index của dòng đang được chọn 
    // Chỉ cần khai báo list này là giao diện tự sinh ra
    mobileFields: [
      { label: 'Ship No', key: 'shipNo' },
      { label: 'Inspection Date', key: 'insDateShow' },
      { label: 'Actions', key: 'actions' },
      { label: 'Owner result', key: 'insResCd' },
      { label: 'Delegation result', key: 'insResDe' },
      { label: 'Maker result', key: 'resPaintMK' },
      { label: 'MH Reject/USD', key: 'mh' },
      { label: 'Description', key: 'itemDesc2' },
      { label: 'QM Part', key: 'qmPartNm' },
      { label: 'Kind Inspection', key: 'kindNm' },
      { label: 'Location', key: 'locNm' },
      { label: 'Department', key: 'deptNm' },
      { label: 'Work group', key: 'respNmeng' },
      { label: 'Witness Plan', key: 'plans' },
      { label: 'Witness Actual', key: 'actuals' },

    ],              

  autSaveYN:'R',
  autDept:'N',
  autChkSection:{},
  // autKmgrSec:'',
  // autVmgrSec:'',
  // autDimSec:'',
  insResChk: 0,
  insResChkDel: 'N',
  shipIncharge: 0,
  clsYn:'N', 
  disabledOwner: false,
  disabledDel: false,
  disabledMaker: false,
  disabledMh: false, 
  titleInput: '',

  }),
  components: {
    DxDateBox,
    // AppButton,
  },

  computed: {
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },

  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    this.init()
     //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang
    
    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
   
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },

  methods: {
        
    btnRetrieve() {
        this.gridMainList = []        
        this.getMainList()
        
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
    init() {
      let toDay = new Date      
      this.stDate = toDay.setDate(toDay.getDate() - 1);
      toDay = new Date
      this.edDate = toDay.setDate(toDay.getDate() + 1);

      this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
      this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

      this.getList()

      if(this.$store.state.user.deptCd === 'ZN'|| this.$store.state.user.deptCd === 'ZB'){
        this.autDept = 'Y'
      }
      

    }, 
    //Edit Dialog
    editItem (item) {

      if(this.$store.state.user.deptCd === 'ZN'|| this.$store.state.user.deptCd === 'ZB'){
        this.titleInput = 'Input Result'
      }else{
        this.titleInput = 'Input Reject M/H'
      }

      this.modeIndex = this.gridMainList.indexOf(item)
      this.inputResult = Object.assign({}, item)

      this.changeSelect(item)
      this.dialog = true
    },
    closeResult () {
      // this.btnRetrieve()
      this.modeIndex = -1
      this.dialog = false

      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },

    async insResultCnt(e){
      let param = {
            shipNo: e.shipNo,
            inspAct: e.inspAct,
            respCd: e.respCd,
            stDate: e.reqDate,
          }

          // getInsResultChk
          await getInsResultChk(param).then(res => {

            if(res.list.length > 0) {
              this.insResChk = res.list[0].insResChk
            }
          })
    },

    async insResultDelYN(e) {
        let param = {            
            insRes: e.insResCd,
          }
       // getInsResultChkDel
          await getInsResultChkDel(param).then(res => {
              if(res.list.length > 0) {
                this.insResChkDel = res.list[0].insResChkDel
                 // Check select result for Delegation
                if( this.autDept === 'Y'){
                  if( this.insResChkDel === 'Y' && e.qcYN ==='N'){
                    this.disabledDel = false
                  }else{
                    this.disabledDel = true
                    this.inputResult.insResDe = ''
                  }
                }else{
                  this.disabledDel = true
                }
              }
          })

          // getEvalPoint
          await getEvalPoint(param).then(res => {
              if(res.list.length > 0) {
                this.insNRes = res.list[0].evaPnt
              }
          })
    },

    async loadCondition(e) {
        let param = {
            shipNo: e.shipNo,
            stDate: e.reqDate,
            userId: this.$store.state.user.userId,
            qmPart: e.qmPart,
            div: 'I',

          }  
          // getShipIncharge
          await getShipIncharge(param).then(res => {
            if(res.list.length > 0) {
              this.shipIncharge = res.list[0].shipIncharge
            }
          })

          // getCloseYN
          await getCloseYN(param).then(res => {
            if(res.list.length > 0) {
              this.clsYn = res.list[0].clsYn
            }
          })
    },

    changeSelect(e) {
      // console.log('changeSelect', e)
      this.insResultCnt(e)
      this.insResultDelYN(e)
      this.protectSelect(e)

    },

    protectSelect(e) {
      // Seclect result for Owner
      if ( this.autDept ==='Y') {
        this.disabledOwner = false
      }else{
        this.disabledOwner = true
      }
      //Propotect for Maker  
      if( this.$store.state.user.deptCd !=  'ZN'){
        this.disabledMaker = true
      }else{
        if(e.qmPart==='P' && (e.deptCd ==='B0'||e.deptCd ==='B1'||e.deptCd ==='C0')){
          this.disabledMaker = false
        }else{
          this.disabledMaker = true
        }
      }
      // Input M/H for Reject result
      if( e.insResCd==='AD'||e.insResCd==='AE'||e.insResCd==='RA'||e.insResCd==='RB'||e.insResCd==='RC'||e.insResCd==='RD'||e.insResCd==='RE'||e.insResCd==='RF') {
        if(this.autDept === 'Y') {
          this.disabledMh = false
        }else{
          if( this.$store.state.user.deptCd !=  e.deptCd) {
            this.disabledMh = true
          }else{
            this.disabledMh = false
          }
        }
      }else{
        this.disabledMh = true
      }

    },

    async saveResult (e) {
      if (this.modeIndex > -1) {
       let params = []
        Object.assign(this.gridMainList[this.modeIndex], e)
          // Save function here        
          // Check condition before Action
          if(this.autDept ==='Y'){
              if(this.autChkSection.autKmgrSec <= 0 ){
                if(this.autChkSection.autKmgrSec == 0 ){
                  // V.MGR and Eng can not modify
                  if (this.insResChk > 0 && this.insResChkDel === 'Y' ) {
                    this.vToastify(this.$t('Only section Chief can modify result for this ship('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                    return
                  }else{// Can PIC/Eng accept result, can't change result again: except make request inspection again
                    if (e.kindCd != 'DIM' && this.shipIncharge == 0 ) { 
                      this.vToastify(this.$t('You can not input result for this ship('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                      return
                    }
                  }

                }else{
                  this.vToastify(this.$t('You do not have authority to change result for this ship('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                  return

                }
              }

              // QM-Accuracy section: Accuracy check before input result (Sub - Block assembly only)
              if (this.autChkSection.autKmgrSec <= 0  && e.kindCd === 'DIM' && this.autDept === 'Y' &&  e.qmPart === 'H' ) {  

                this.vToastify(this.$t('You do not have authority to save Accuracy test item('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                return
              }   
              
              if (this.autChkSection.autKmgrSec <= 0 && e.kindCd !== 'DIM' && this.autChkSection.autDimSec > 0 ) {  		          
                this.vToastify(this.$t('You only have authority to save Accuracy test item('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                return
              }

              if (this.clsYn === 'Y' ) {
                this.vToastify(this.$t('Can not save data because inspection of this month is closed'))
                return
              }
              
              if (e.qcYN === 'N') {
                if (e.insResCd ==='AA'||e.insResCd === 'AC'||e.insResCd === 'AD'||e.insResCd === 'AE'||e.insResCd === 'LQ'||e.insResCd === 'RA'||e.insResCd === 'RB'||e.insResCd === 'RC'||e.insResCd === 'RD'||e.insResCd === 'RE'||e.insResCd === 'RF') {                  
                  if ((e.insResDe === null) || e.insResDe === '' ) {
                    if (e.kindCd !== 'DIM') {
                      this.vToastify(this.$t('Please select a Delegation result')) 
                      return
                    }
                  }
            
                }
              }

          }

          params.push({
                    userId: this.$store.state.user.userId,
                    deptCd: this.$store.state.user.deptCd,        
                    reqDate: e.reqDate,
                    insDate: e.insDate,
                    shipNo: e.shipNo,
                    respCd: e.respCd,
                    inspAct: e.inspAct,
                    insRes: e.insResCd,
                    insResDe: e.insResDe,
                    resPaintMK: e.resPaintMK,
                    kindCd: e.kindCd,
                    acQmCfm: e.acQmCfm,
                    qcYN: e.qcYN,
                    mh: e.mh,
                    insNRes: this.insNRes,
                    insNResLQC: this.insNRes,
                    wowAct: e.wowAct=== true?'Y':'N',
                    wclAct: e.wclAct=== true?'Y':'N',
                    qmPart: e.qmPart,
              })
              
              try {
                this.openLoading('searching')

                v80b1020Update(params).then(res => {
                  if(res.body == 'Y'){
                    notify(this.$t('Inspection Result Update is completed.'), 'success', 3000)
                  }else {
                    this.vToastify(this.$t('An error has been occurred while update data :'), 'warn')
                  }
                  this.btnRetrieve()
                  
                })
                    .catch(error => {
                      this.endLoading()
                    })
              }finally {
                this.endLoading()
              }    

      } else {
        this.gridMainList.push(this.inputResult)
      }
      this.closeResult()

      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'

    },

    //getList
    async getList() {
      try {
          this.openLoading('searching')
          let params = {
            cdDiv: '01',
          }

          let params1 = {
            cdDiv: '18',
          }

          let param = {
            sysCd: '80',//this.$store.state.system.sysCd,
            menuId: this.$route.meta.menu_id,
            userId: this.$store.state.user.userId,
          }
          // getAutSaveYN
          await getAutSaveYN(param).then(res => {
            if(res.list.length > 0) {
              this.autSaveYN = res.list[0].saveYn
            }
          })
          // getAutInspection
          await getAutInspection(param).then(res => {
            if(res.list.length > 0) {
              this.autChkSection = res.list[0]
              // autDimSec, autKmgrSec, autVmgrSec
            }
          })

          await getQMPartList(params).then(res => {
            this.qmPartNameList.push('All')
            res.list.forEach(e => {
              this.qmPartNameList.push(e.qmPart + ' : ' + e.qmPartNm)
            });
            this.qmPartName = this.qmPartNameList[0]
          })

          // getShipList
          await getShipList(params).then(res => {
                  this.shipNoList.push('All')
                  res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                  });
                  this.shipNo = this.shipNoList[0]
                })

          // getDepartment         
          if (this.$store.state.user.deptCd !='ZN' && this.$store.state.user.deptCd !='ZB'){
              this.deptNameList.push(this.$store.state.user.deptCd + ' : ' + this.$store.state.user.deptNm)
              this.deptName = this.deptNameList[0]
              this.deptCd = this.$store.state.user.deptCd
          }else{
            await getDeptList(params).then(res => {
                    this.deptNameList.push('All')
                    res.list.forEach(e => {
                      this.deptNameList.push(e.deptCd + ' : ' + e.deptNm)
                    });
                    this.deptName = this.deptNameList[0]
                  })
          }      
          // Owner Result
          await getResultList(params).then(res => {
                let list = []
                res.list.forEach(e => {
                  if(e != null){
                    list.push({insResNm: e.insResCd + ': ' + e.insResNm , insResCd: e.insResCd, resPnt: e.resPnt})
                  } else {
                    list.push({insResNm: '', insResCd: '', resPnt: ''})
                  }
                });
                this.resultInspList = list
                this.resultInsp = this.resultInspList[0]
              }) 
          // Delegation Result
          await getResultList(params1).then(res => {
                let list = []
                res.list.forEach(e => {
                  if(e != null){
                    list.push({insResDeNm: e.insResCd + ': ' + e.insResNm , insResDe: e.insResCd, resPnt: e.resPnt})
                  } else {
                    list.push({insResDeNm: '', insResDe: '', resPnt: ''})
                  }
                });
                this.resultInspDeList = list
                this.resultInspDe = this.resultInspDeList[0]
              })
          // Maker Result (for Painting)
          await getResultList(params).then(res => {
                let list = []
                res.list.forEach(e => {
                  if(e != null){
                    list.push({resPaintMKNm: e.insResCd + ': ' + e.insResNm , resPaintMK: e.insResCd})
                  } else {
                    list.push({resPaintMKNm: '', resPaintMK: ''})
                  }
                });
                this.resultInspPaintMKList = list
              })    

          } finally {
              this.groupList()
              this.endLoading()
          }

    },
    //get Group
    groupList(){
    this.respNameList = []

    let supdeptCd = this.deptName
    supdeptCd = supdeptCd.split(' : ')
    this.deptCd = supdeptCd[0]
    let params = {
      deptCd: this.deptCd ==='All'?'':this.deptCd,
    }

    getRespList(params).then(res => {
      this.respNameList.push('All')
      res.list.forEach(e => {
        this.respNameList.push(e.respCd + ' : ' + e.respNm)										
      });
      this.respName = this.respNameList[0]
    })
  },        

  async getMainList() {
        try {
            this.openLoading('searching')            
            let respName = this.respName
                respName = respName.split(' : ')
                this.respCd = respName[0]

            let qmPartName = this.qmPartName
                qmPartName = qmPartName.split(' : ')  
                this.qmPart = qmPartName[0]  
                          
            let params = {
                stDate: this.stDate,
                edDate: this.edDate,
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                deptCd: this.deptCd === 'All' ? '' : this.deptCd,
                respCd: this.respCd === 'All' ? '' : this.respCd,
                qmPart: this.qmPart === 'All' ? '' : this.qmPart,
                resCd: !this.resultInsp.insResCd ? '' : this.resultInsp.insResCd,

            }

            await v80b1020List(params).then(res => {
              let list = []
              // Hàm chuyển đổi chung
              const toBool = (val) => val === 'Y';

                res.list.forEach(e => {
                  list.push({
                    ...e,
                    insDateShow: e.insDate + '  '+ e.insTime,
                    reqDateShow: e.reqDate + '  '+ e.reqTime,
                    insLocShow: e.insLoc + '/ '+ e.insLocNo,
                    insResCd: e.insRes===null ? '' : e.insRes,
                    insResDe: e.insResDe===null ? '' : e.insResDe,
                    wowShow: toBool(e.wow),
                    wclShow: toBool(e.wcl),
                    wowAct: toBool(e.wowAct),
                    wclAct: toBool(e.wclAct),
                    resPaintMK: e.resPaintMK===null ? '' : e.resPaintMK,
                  })
                  
                });

                this.gridMainList = list
                this.listSize = this.gridMainList.length;

                if (this.listSize > 0 && this.isMobileDevice) {
                  this.panel = [];
                }
                // console.log('######listSize===>', this.listSize)
            })

        } finally {
            this.endLoading()
        }
    },

  getColor (value) {
      if (value > 400) return 'red'
      else if (value > 200) return 'orange'
      else return 'green'
  },  

  // Hàm lưu độ rộng vào localStorage
  saveColumnWidths() {
    const widths = {};
    const ths = this.$el.querySelectorAll('.v-data-table th');
    
    ths.forEach((th, index) => {
      // Lưu theo index hoặc value của header để không bị lẫn
      widths[index] = th.style.width;
    });
    
    localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
  },

  // Hàm khôi phục độ rộng khi vào lại trang
  loadColumnWidths() {
    const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
    if (savedWidths) {
      const widths = JSON.parse(savedWidths);
      this.$nextTick(() => {
        const ths = this.$el.querySelectorAll('.v-data-table th');
        ths.forEach((th, index) => {
          if (widths[index]) {
            th.style.width = widths[index];
          }
        });
      });
    }
  },

},

};
</script>
<style>
/* Import file CSS dùng chung cho toàn bộ Mobile Card */
/* Sử dụng dấu ~ trước @ để Webpack nhận diện đúng alias */
@import "~@/assets/css/mobile-table.css";

/* Các CSS tùy chỉnh khác cho menu này */
.border-bottom {
  border-bottom: 1px dashed #eee;
}
.v-card__text {
  max-height: 70vh; /* Giới hạn chiều cao popup trên mobile */
}

.custom-pc-row td .v-image__image {
  background-size: contain !important; /* Đảm bảo ảnh vẽ kỹ thuật luôn thấy hết chi tiết */
}

/* Trong mobile-table.css hoặc style của v80w1010.vue */
.cursor-pointer {
  cursor: zoom-in !important; /* Đổi icon chuột thành hình kính lúp */
  transition: opacity 0.3s;
}

.cursor-pointer:hover {
  opacity: 0.8; /* Hiệu ứng mờ nhẹ khi di chuột qua */
}

/* Hiệu ứng cho icon kẹp giấy */
.pdf-icon-btn {
  transition: all 0.2s ease-in-out; /* Giúp hiệu ứng mượt mà hơn */
  cursor: pointer;
}

/* Khi di chuột vào trên PC */
.pdf-icon-btn:hover {
  transform: scale(2); /* Phóng to 30% */
  color: #d32f2f !important; /* Đổi sang màu đỏ đậm hơn (v-red-darken-2) */
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.2)); /* Thêm bóng đổ nhẹ */
}

/* Hiệu ứng khi nhấn vào (Active) */
.pdf-icon-btn:active {
  transform: scale(1.1);
  opacity: 0.7;
}

.cursor-pointer {
  cursor: pointer;
}

.hover-cell-style {
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.hover-cell-style:hover {
  background-color: rgba(25, 118, 210, 0.1); /* Màu xanh nhạt khi hover */
}

/* Tùy chỉnh Tooltip để không bị che khuất */
.v-tooltip__content {
  opacity: 1 !important;
  box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
}
/* Tạo đường kẻ đứt nhẹ nhàng cho Detail */
.border-bottom-light {
  border-bottom: 1px dashed #e0e0e0; /* Tạo đường kẻ đứt nhẹ nhàng */
}
.v-card__text {
  line-height: 1.4;
}
</style>
